export const DEFAULT_PATIENT_PAYMENT_TAB = "patient-payment";

export const PATIENT_PAYMENT_TABS = [
  {
    label: "Patient Payment",
    value: DEFAULT_PATIENT_PAYMENT_TAB,
  },
  // {
  //   label: "Insurance Payment",
  //   value: "insurance-payment",
  // },
];

export type PatientPaymentFilters = {
  patientName: { value: string; label: string } | null;
  transactionDate: string | null;
  transactionId: string | null;
  paymentMethod: { value: string; label: string } | null;
  visitId: { value: string; label: string } | null;
  superbillId: { value: string; label: string } | null;
  claimId: string | null;
};
export const PATIENT_PAYMENT_FILTER_KEYS = [
  "transactionDate",
  "transactionId",
  "paymentMethod",
  "patientName",
  "visitId",
  "invoiceId",
  "claimId",
];

export const DEFAULT_FILTERS = {
  patientName: null,
  transactionDate: null,
  transactionId: null,
  paymentMethod: null,
  visitId: null,
  superbillId: null,
  claimId: null,
};
export const PATIENT_PAYMENT_FILTER_INITIAL_EXPANDED = Object.entries(
  DEFAULT_FILTERS
).reduce(
  (acc, [k]) => {
    acc[k] = false;
    return acc;
  },
  {} as Record<string, boolean>
);

export const PATIENT_PAYMENT_INITIAL_VALUES = {
  patient: undefined,
  amount: undefined,
  paymentMode: undefined,
  bankPaymentMode: undefined,
  transactionId: undefined,
  billId: [],
  claimId: [],
  note: "",
  paymentDate: null,
  insurancePayer: undefined,

  collectedBy: undefined,
  paymentCategory: undefined,
  encounter: [],
  unappliedAmount: undefined,
  appliedAmount: undefined,
};

// AC4 (ECRH-5090): Payment Mode dropdown values.
// "Check" has no dedicated backend enum yet (closest existing is CHEQUE used for
// bankPaymentMode); "Apply credit balance" maps to PATIENT_WALLET.
export const PATIENT_PAYMENT_MODE_OPTIONS = [
  {
    value: "ONLINE",
    label: "Card",
  },
  {
    value: "CASH",
    label: "Cash",
  },
  {
    value: "CHECK",
    label: "Cheque",
  },
  {
    value: "APPLY_CREDIT_BALANCE",
    label: "Apply credit balance",
  },
];

// Insurance Payment tab: the patient payment modes plus ACH. Cheque already
// exists in PATIENT_PAYMENT_MODE_OPTIONS, so only ACH is appended.
export const INSURANCE_PAYMENT_MODE_OPTIONS = [
  ...PATIENT_PAYMENT_MODE_OPTIONS,
  {
    value: "ACH",
    label: "ACH",
  },
];

// ECRH-5101: single source of truth for the Payment Mode label so the listing
// table and the View Payment drawer render the same value for a given
// paymentMode (e.g. ONLINE → "Card" in both). Covers every
// GetPatientAllPaymentPaymentModeEnum value.
const PAYMENT_MODE_LABEL: Record<string, string> = {
  ONLINE: "Card",
  CASH: "Cash",
  CHECK: "Cheque",
  BANK: "Bank",
  ACH: "ACH",
  APPLY_CREDIT_BALANCE: "Apply credit balance",
};

export const getPaymentModeLabel = (paymentMode?: string | null): string => {
  if (!paymentMode) return "-";
  return PAYMENT_MODE_LABEL[paymentMode] ?? paymentMode;
};

// Category dropdown — mirrors PatientCardPaymentCategoryEnum.
// Single cumulative dropdown (no Invoice/Prepayment split): the user picks any
// value and it is mapped to the payment record shown in the listing.
export const PATIENT_PAYMENT_CATEGORY_OPTIONS = [
  { value: "COPAY", label: "Copay" },
  { value: "COINSURANCE", label: "Coinsurance" },
  { value: "DEDUCTIBLE", label: "Deductible" },
  { value: "SELF_PAY", label: "Self-Pay" },
  { value: "ADVANCE", label: "Advance" },
  { value: "PR", label: "PR" },
  { value: "OUT_OF_NETWORK", label: "Out of Network" },
];
